module.exports = __webpack_public_path__ + "static/media/Nonord-C-trial-Kap.3f21740a.mp3";